import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { ServiceProviderR } from "../../pages/service-provider/routes";

export const ServiceProviderMenuList = withRouter(() => {
  return (
    <nav className="menu">
      <p className="menu-label">メニュー</p>
      <ul className="menu-list">
        <li>
          <Link to={ServiceProviderR.Home.link({})}>テナント一覧</Link>
        </li>
        <li>
          <Link to={ServiceProviderR.BannerNotice.link({})}>
            バナー通知表示設定
          </Link>
        </li>
        <li>
          <Link to={ServiceProviderR.ProductDocs.link({})}>マニュアル設定</Link>
        </li>
      </ul>
    </nav>
  );
});
